import React from "react";
import {Icon, TabControlButton, TabControlPage} from "peggirkit";
import {ShoppingCartIcon} from "@heroicons/react/20/solid";
import {OrderEditorTabProps} from "@widgets/pos/order/OrderEditor";
import MenuOverview from "@widgets/pos/order/menu/MenuOverview";
import {useIntl} from "react-intl";

const MenuTab = (tabProps: OrderEditorTabProps) => {
    const intl = useIntl();

    return (
        <TabControlPage
            tabButton={
                <TabControlButton iconBefore={<Icon icon={ShoppingCartIcon}/>}>
                    {intl.formatMessage({id: "menu"})}
                </TabControlButton>
            }
        >
            <MenuOverview {...tabProps}/>
        </TabControlPage>
    );
};

export default MenuTab;